import {actions as A} from '../constants/actions';

const defaultState = {
  listForExcel: [],
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL:
      return {...state, loading: true, error: false, errorMessage: null};

    case A.GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL_SUCCESS:
      const {listForExcel} = payload;

      return {...state, loading: false, error: false, errorMessage: null, listForExcel};

    case A.GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL_FAILURE:
      return {...state, loading: false, error: true, errorMessage: payload};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}

